import { render, staticRenderFns } from "./CategoryImageHeading.vue?vue&type=template&id=70464efd&scoped=true&"
import script from "./CategoryImageHeading.vue?vue&type=script&lang=js&"
export * from "./CategoryImageHeading.vue?vue&type=script&lang=js&"
import style0 from "./CategoryImageHeading.vue?vue&type=style&index=0&id=70464efd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70464efd",
  null
  
)

export default component.exports